import React from 'react'
import {clone} from 'lodash'
import TextField from 'material-ui-legacy/TextField'
import {grey900} from 'material-ui-legacy/styles/colors'

const alignRightLabel = {
  textAlign: 'right',
  right: '0px'
}

const alignRightFloatingLabel = {
  textAlign: 'right',
  right: '-6%'
}

const alignRightInputStyle = {
  textAlign: 'right',
  color: grey900
}

const DisplayField = (props) => {
  const color = props.color || grey900
  let newProps = clone(props)
  newProps.inputStyle = {}
  if (props.alignRight) {
    newProps.floatingLabelStyle = alignRightLabel
    newProps.floatingLabelShrinkStyle = alignRightFloatingLabel
    newProps.inputStyle = alignRightInputStyle
  }
  newProps.inputStyle.color = color
  delete newProps.alignRight
  delete newProps.color
  return (
    <TextField
      underlineDisabledStyle={{display: 'none'}}
      fullWidth
      disabled
      {...newProps}
    />
  )
}

export default DisplayField



// WEBPACK FOOTER //
// ./src/components/UI/DisplayField.jsx